module.exports = __webpack_public_path__ + "static/media/foodo2.2a0cd072.png";